<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import LangToggle from './LangToggle.vue'
import { onUnmounted, ref, watch } from 'vue'

const logo = '/brand/infoscape-logo.svg'
const { t } = useI18n()

const navOpen = ref(false)
function toggleNav() {
  navOpen.value = !navOpen.value
}
function closeNav() {
  navOpen.value = false
}

watch(navOpen, (v) => {
  if (typeof document === 'undefined') return
  document.documentElement.style.overflow = v ? 'hidden' : ''
})

onUnmounted(() => {
  if (typeof document !== 'undefined') {
    document.documentElement.style.overflow = ''
  }
})
</script>

<template>
  <nav id="navbar">
    <div class="nav-inner">
      <div class="nav-brand">
        <a href="#top" class="nav-logo">
          <img :src="logo" alt="InfoScape – Human · Data · AI" class="nav-logo-img" />
        </a>
      </div>
      <ul class="nav-links" id="navLinks" :class="{ open: navOpen }">
        <li><a href="#workspace" @click="closeNav">{{ t('nav.workspace') }}</a></li>
        <li><a href="#atlas" @click="closeNav">{{ t('nav.atlas') }}</a></li>
        <li><a href="#sparks" @click="closeNav">{{ t('nav.localAi') }}</a></li>
        <li><a href="#consulting" @click="closeNav">{{ t('nav.consulting') }}</a></li>
        <li><a href="#faq" @click="closeNav">{{ t('nav.faq') }}</a></li>
        <li><a href="#contact" @click="closeNav">{{ t('nav.contact') }}</a></li>
        <li class="nav-lang-mobile"><LangToggle /></li>
      </ul>
      <LangToggle class="lang-toggle-desktop" />
      <button
        class="nav-toggle"
        id="navToggle"
        :aria-label="t('nav.ariaMenu')"
        :aria-expanded="navOpen ? 'true' : 'false'"
        @click="toggleNav"
      >
        <span></span><span></span><span></span>
      </button>
    </div>
  </nav>
  <Transition name="nav-overlay-fade">
    <div
      v-if="navOpen"
      class="nav-overlay"
      aria-hidden="true"
      @click="closeNav"
    ></div>
  </Transition>
</template>

<style>
.nav-lang-mobile { display: none; }

@media (max-width: 1100px) {
  .lang-toggle-desktop { display: none !important; }
  .nav-links.open .nav-lang-mobile {
    display: flex;
    justify-content: center;
    margin-top: 12px;
  }
  .nav-links.open .nav-lang-mobile .lang-toggle {
    margin: 0 !important;
  }
}
</style>
